@charset "UTF-8";

@use "_variables";

:export {
  widthLeftArea: variables.$widthLeftArea
}
